import { Popover } from 'antd';
import { APPOINTMENT_STATUS, BLOCK_HOURS_CONFIG, BREAK_STAFF_CONFIG, CALENDAR_ITEM_TYPES, CANCEL_CONFIG, CHECK_IN_CONFIG, CONFIRM_CONFIG, listCalendarItemTypesSignal, MULTI_CONFIG, NEW_CONFIG, NO_SHOW_CONFIG, saveAppointmentColor } from 'features/appointment/services/constants';
import React, { CSSProperties, useState } from 'react';
import styled from 'styled-components';
import colors from './colors.json';
import { useSignals } from '@preact/signals-react/runtime';
import { useAppDispatch } from 'store/hooks';
import appointmentActions from 'features/appointment/services/actions';

const ColorContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  align-items: flex-start;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid #CCD4DC;
  background: #FFF;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.15);
  .title {
    color: #1D2129;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .container-colors {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 4px;
  }
  .color-box {
    width: 81.845px;
    height: 54.926px;
    border-radius: 4px;
    margin: 3px;
  }
  .status-box-item {
    border-radius: 4px;
    &.active {
      box-shadow: 0px 0px 0px 4px #DC5500;
    }
  }
`;
type ContentColorsProps = {
  activeId?: string;
  onChange?: (id: string) => void;
};
const ContentColors: React.FC<ContentColorsProps> = ({ activeId, onChange }) => {
  return (
    <ColorContainer>
      <p className="title">Change theme</p>
      <div className="container-colors">
        {
          colors.map((o, i) => (
            <button type='button' key={i} className={`status-box-item ${activeId === o.id ? 'active' : ''}`} onClick={() => {
              onChange?.(o.id);
            }}>
              <div className="color-box" style={{ background: o.fill, border: `1px solid ${o.stroke}` }} />
            </button>
          ))
        }
      </div>
    </ColorContainer>
  );
};
const overlayInnerStyle: CSSProperties = { borderRadius: 0, boxShadow: 'none', padding: 0, background: 'transparent' };


const StatusBoxItem = ({ data: o }: {
  data: {
    label: string;
    value: any;
    stroke: string;
    fill: string;
  }
}) => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen} overlayInnerStyle={overlayInnerStyle} placement='bottomLeft'
      content={<ContentColors activeId={`${o.stroke}_${o.fill}`} onChange={(id) => {
        const [stroke, fill] = id.split('_');
        saveAppointmentColor(o.value, fill, stroke);
        dispatch(appointmentActions.updateSettingBackground.fetch({
          color: id,
          status: o.value,
        }));
        setOpen(false);
      }} />} trigger={'click'}>

      <button type='button' className="status-box-item">
        <div className="color-box" style={{ background: o.stroke }} >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <path d="M5.91919 1.11049C6.01415 0.983873 6.20408 0.849343 6.35443 0.991786C9.24286 3.85647 12.1155 6.7449 14.996 9.61749C15.1068 9.7362 15.2571 9.83907 15.2809 10.0132C15.3283 10.2031 15.2334 10.393 15.0909 10.5117C12.8831 12.7117 10.6831 14.9195 8.47525 17.1195C8.29324 17.3173 7.96879 17.3252 7.78677 17.1274C5.571 14.9116 3.35522 12.6958 1.13944 10.4801C0.925777 10.306 0.917863 9.93403 1.12361 9.75202C2.92789 7.94775 4.73217 6.13556 6.54436 4.33919C5.99041 3.80108 5.44438 3.23922 4.89044 2.69319C4.80339 2.61405 4.73217 2.51118 4.67677 2.4083C5.03288 1.93349 5.50769 1.54573 5.91919 1.11049ZM7.99253 5.53413C6.48896 7.05352 4.96957 8.565 3.45809 10.0765C6.5681 10.0765 9.6781 10.0844 12.7881 10.0686C11.2371 8.51752 9.68601 6.97439 8.14288 5.41543C8.0954 5.455 8.04001 5.49456 7.99253 5.53413Z" fill={'#F1EFFF'} />
            <path d="M16.2225 14.4053C16.634 13.7248 17.1167 13.0917 17.6469 12.5061C18.3512 13.3291 19.0239 14.1996 19.467 15.1967C19.6807 15.6715 19.7994 16.2175 19.6411 16.724C19.4196 17.6024 18.5807 18.2988 17.6628 18.283C16.6815 18.3225 15.7556 17.547 15.6053 16.5816C15.447 15.806 15.8506 15.0622 16.2225 14.4053Z" fill={'#F1EFFF'} />
            <path d="M0.545908 20.3878C0.537995 20.2374 0.688351 20.1425 0.822881 20.1662C7.60474 20.1662 14.3866 20.1662 21.1685 20.1662C21.2713 20.1504 21.3663 20.2137 21.4534 20.2691C21.4613 21.013 21.4613 21.7568 21.4534 22.5007C21.4613 22.6511 21.2872 22.6906 21.1764 22.6827C14.3945 22.6827 7.61266 22.6827 0.830794 22.6827C0.672524 22.7144 0.537995 22.5878 0.553822 22.4295C0.537995 21.741 0.537995 21.0604 0.545908 20.3878Z" fill={'#F1EFFF'} />
          </svg>
        </div>
        <span>{o.label}</span>
      </button>
    </Popover>
  );
};
const StatusBar = () => {
  useSignals();
  return (
    <StatusBarStyled>
      {[
        {
          label: 'Multiple',
          value: 'MULTI',
          stroke: MULTI_CONFIG.value.stroke,
          fill: MULTI_CONFIG.value.fill,
        },
        {
          label: 'Appointment',
          value: APPOINTMENT_STATUS.NEW,
          fill: NEW_CONFIG.value.fill,
          stroke: NEW_CONFIG.value.stroke,
        },
        {
          label: 'Confirm',
          value: APPOINTMENT_STATUS.CONFIRM,
          fill: CONFIRM_CONFIG.value.fill,
          stroke: CONFIRM_CONFIG.value.stroke,
        },
        {
          label: 'Check In',
          value: APPOINTMENT_STATUS.CHECK_IN,
          fill: CHECK_IN_CONFIG.value.fill,
          stroke: CHECK_IN_CONFIG.value.stroke,
        },
        {
          label: 'Cancel',
          value: APPOINTMENT_STATUS.CANCEL,
          fill: CANCEL_CONFIG.value.fill,
          stroke: CANCEL_CONFIG.value.stroke,
        },
        {
          label: 'No show',
          value: APPOINTMENT_STATUS.NO_SHOW,
          fill: NO_SHOW_CONFIG.value.fill,
          stroke: NO_SHOW_CONFIG.value.stroke,
        },
        {
          label: 'Staff Break',
          value: CALENDAR_ITEM_TYPES.BREAK_STAFF,
          fill: BREAK_STAFF_CONFIG.value.fill,
          stroke: BREAK_STAFF_CONFIG.value.stroke,
        },
        {
          label: 'Block Times',
          value: CALENDAR_ITEM_TYPES.BLOCK_HOURS,
          fill: BLOCK_HOURS_CONFIG.value.fill,
          stroke: BLOCK_HOURS_CONFIG.value.stroke,
        },
      ].map((o, i) => (
        <StatusBoxItem data={o} key={o.value} />
      ))}
    </StatusBarStyled>
  );
};

export default StatusBar;


const StatusBarStyled = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    .status-box-item {
      height: 3.5rem;
      background: #fff;
      display: flex;
      align-items: center;
      border: 1.5px solid #1D2129;
      border-radius: 3.5rem;
      gap: 8px;
      padding: 0 8px;
      padding-right: 16px;
      span {
        color: #1D2129;
        text-align: center;
        text-transform: uppercase;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      .color-box {
        display: flex;
        width: 32px;
        height: 32px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        aspect-ratio: 1/1;
        border-radius: 4px;
        background: #4F1787;
      }
    }
`;
